var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "has-return": "",
          "has-save": _vm.provider.ssn,
          page: _vm.page
        },
        on: {
          onReturn: function($event) {
            return _vm.$router.push({ name: "ProviderSearch" })
          },
          onSave: _vm.save
        }
      }),
      _c(
        "div",
        [
          _c(
            "validation-observer",
            {
              ref: "provider-fisical-direction-form",
              attrs: { novalidate: "", slim: "" }
            },
            [
              !_vm.provider.ssn
                ? _c("div", [
                    _c("div", { staticClass: "bg-secondary-9 p-3" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-4" }, [
                          _c(
                            "div",
                            { staticClass: "ml-2 mb-4" },
                            [
                              _c("icon-view", {
                                attrs: {
                                  icon: "fa fa-search pb-1",
                                  "icon-background": "#fff",
                                  "icon-color": "#F57E4A",
                                  title: "Búsqueda de SSN"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-sm d-flex flex-sm-column flex-md-row align-items-start"
                            },
                            [
                              _c("validation-provider", {
                                staticClass: "flex-grow-1",
                                attrs: {
                                  "custom-messages": {
                                    required:
                                      "El número de seguro social es requerido.",
                                    completePersonalSsn:
                                      "El número de seguro social no es válido."
                                  },
                                  rules: "completePersonalSsn|required"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-input", {
                                            staticClass: "mt-n2",
                                            attrs: {
                                              error: errors[0],
                                              label: "SSN Patronal:",
                                              "mask-type": "SSNPatronal",
                                              placeholder: "xxx-xxxxxx",
                                              type: "text"
                                            },
                                            model: {
                                              value: _vm.ssn,
                                              callback: function($$v) {
                                                _vm.ssn = $$v
                                              },
                                              expression: "ssn"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3465231815
                                )
                              }),
                              _c("action-button", {
                                staticClass: "mt-4 px-4 ml-4",
                                attrs: {
                                  i: "fa fa-search",
                                  text: "Buscar",
                                  type: "submit",
                                  variant: "success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.validateSsn()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm.searchApplied
                        ? _c(
                            "div",
                            [
                              _c("custom-separator", {
                                staticClass: "my-4",
                                attrs: {
                                  text: "Resultados de Propuesta de Servicios"
                                }
                              }),
                              _vm.proposals.length
                                ? _c(
                                    "div",
                                    _vm._l(_vm.proposals, function(
                                      item,
                                      index
                                    ) {
                                      return _c("proposal-request-result-row", {
                                        key: index,
                                        staticClass: "m-3",
                                        attrs: { data: item },
                                        on: {
                                          select:
                                            _vm.onSelectProposalRequestHandler
                                        }
                                      })
                                    }),
                                    1
                                  )
                                : _c("custom-result-not-found", {
                                    attrs: {
                                      text: "No hay información disponible"
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "my-3 col-12" },
                      [
                        _c("provider-general-info-form", {
                          ref: "generalInfoForm",
                          attrs: {
                            "has-primary-provider":
                              _vm.provider.primaryProvider.ssn != "",
                            "proposal-info": _vm.proposalInfo,
                            "provider-info": _vm.provider
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "my-3 col-12" },
                      [
                        _c("provider-create-fisical-direction-form", {
                          ref: "physicalAddressForm",
                          attrs: { "proposal-info": _vm.proposalInfo }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "my-3 col-12" },
                      [
                        _c("provider-create-primary-contact-information", {
                          ref: "primaryContactForm",
                          attrs: {
                            "civil-statuses": _vm.civilStatuses,
                            "proposal-info": _vm.proposalInfo
                          }
                        })
                      ],
                      1
                    )
                  ])
            ]
          )
        ],
        1
      ),
      _c(
        "custom-modal",
        {
          attrs: {
            "cancel-text": "No",
            icon: "fa fa-exclamation",
            "save-text": "Sí",
            title: "Aviso",
            value: _vm.modal.show
          },
          on: { cancel: _vm.modalCanceled, save: _vm.modalConfirmed }
        },
        [_vm._v(" " + _vm._s(_vm.Message) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }